module.exports = __webpack_public_path__ + "static/media/Website.65504b33.svg";